import React, { useEffect, useRef } from 'react';

const CircleEffect = ({text = '', setClass, setClassDoodle = null, setColor = '#EA2427', type = 'circle'}) => {
  const pathRef = useRef(null);
  const targetRef = useRef(null);

  useEffect(() => {
    const path = pathRef.current;
    const target = targetRef.current;

    if (!path || !target) return;

    const length = path.getTotalLength();

    path.style.strokeDasharray = length;
    path.style.strokeDashoffset = length;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          path.style.strokeDashoffset = 0;
        } else {
          path.style.strokeDashoffset = length;
        }
      },
      { threshold: 0.5 }
    );

    observer.observe(target);

    return () => observer.disconnect(); // Cleanup
  }, []);

  return (
        <span className="relative inline-block">
          <b
            className={setClass ? setClass : "text-[#034694] font-semibold text-[25px] sm:text-[45px] md:text-[45px] lg:text-[60px]"}
            ref={targetRef}
          >
            {text}
          </b>
          <svg
            className={`${setClassDoodle ? setClassDoodle : '-bottom-14 md:-bottom-7 h-[145px] md:h-[140px] w-[90px] md:w-[210px] left-[-2px] md:left-[-2px]'} underline-svg absolute`}
            viewBox="0 0 300 12"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              ref={pathRef}
              className={type === 'circle' ? "animated-circle" : "animated-underline"}
              d={type === 'circle' ? "M 4.954 17.245 Q 30 -52 133.205 -40.87 T 232.404 28.938 C 221.67 83.428 181.766 84.077 149.972 89.268 C 32 89 -1 31 15.985 -0.598 C 17.607 -4.816 44.534 -32.067 39.019 -25.254 C 144 -73 240.162 -20.712 229.456 28.925 C 208.369 126.252 27 73 17 43 C -1.92 -19.642 68 -31 74 -35" : "M 9.538 8.785 Q 75 4 150 8 T 260 11 L 10.884 6.435 L 260.559 7.43"}
              fill="none"
              stroke={setColor}
              strokeWidth="1.8"
              strokeLinecap="round"
            />
          </svg>
        </span>
  );
};

export default CircleEffect;
